import * as cryptoJS from "crypto-js";

export interface CustomerPortalToken {
  companyId: number;
  customerId: number;
  jobId: number;
}

export interface ForgotPasswordToken {
  customerUserId: number;
  companyId: number;
}

export const checkTokenCustomerInvite = <T>(token: string, secretKeyPassword: string) => {
  try {
    if (token && secretKeyPassword) {
      token = token?.replace(/-/gi, "/");

      const decryptedBytes = cryptoJS.AES.decrypt(token, secretKeyPassword);

      const customerPortalTokenString = decryptedBytes.toString(cryptoJS.enc.Utf8);

      const customerPortalToken = customerPortalTokenString
        ? (JSON.parse(customerPortalTokenString) as T)
        : null;

      return customerPortalToken;
    }
  } catch (error) {
    console.error(error);
  }
};
